if (!customElements.get('sweetness-info')) {
  customElements.define(
    'sweetness-info',
    class SweetnessInfo extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.weine-sweetness-info__button');
        this.popup = this.querySelector('.weine-sweetness-info__popup');
        this.closeButton = this.querySelector('.weine-sweetness-info__close');

        this.button.addEventListener('click', this.toggle.bind(this));
        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.close.bind(this));
        }

        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleKeyup = this.handleKeyup.bind(this);
      }

      toggle(event) {
        event.preventDefault();
        const isOpen = this.button.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.popup.removeAttribute('hidden');
        document.addEventListener('click', this.handleOutsideClick);
        document.addEventListener('keyup', this.handleKeyup);
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.popup.setAttribute('hidden', '');
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keyup', this.handleKeyup);
      }

      handleOutsideClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      handleKeyup(event) {
        if (event.key === 'Escape') {
          this.close();
          this.button.focus();
        }
      }
    }
  );
}
